// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__FV2fb","overflowing":"ReadFullNote_overflowing__1K-Lo"};